import { useContext } from 'react';
import { useLocalObservable } from 'mobx-react';

import { ManageBookingService } from '@ibe/services';

import useApi from './useApi';
import { ManageBookingContext } from './Contexts';

/*
 *  This is a convenient way or shortcut to get an instance of the manage booking service.
 *  It will inject the API (with Auth) for you.
 */

function useManageBookingService(): ManageBookingService {
  const context = useContext(ManageBookingContext);
  const manageBookingService = useLocalObservable<ManageBookingService>(() => context);
  const api = useApi();

  manageBookingService.setApi(api);

  return manageBookingService;
}

export default useManageBookingService;
